<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ZQHLXe/tc-custom/9781627794275.jpg?1731883574693" alt="This image is the cover for the book I Will Send Rain"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">I Will Send Rain
      </h1>
      <p class="bookDescription body article font2">
        <p>“<b>A book about Oklahoma in the 1930s demands a spare . . . style to match the landscape. <i>I Will Send Rain</i> obliges . . . .evocative . . . timeless.” —<i>New York Times Book Review</i></b><br/><br/>Annie Bell can’t escape the dust. It’s in her hair, covering the windowsills, coating the animals in the barn, in the corners of her children’s dry, cracked lips. It’s 1934 and the Bell farm in Mulehead, Oklahoma is struggling as the earliest storms of The Dust Bowl descend. All around them the wheat harvests are drying out and people are packing up their belongings as storms lay waste to the Great Plains. As the Bells wait for the rains to come, Annie and each member of her family are pulled in different directions. Annie’s fragile young son, Fred, suffers from dust pneumonia; her headstrong daughter, Birdie, flush with first love, is choosing a dangerous path out of Mulehead; and Samuel, her husband, is plagued by disturbing dreams of rain.<br/><br/>With her warm storytelling and beautiful prose, award-winning author Rae Meadows brings to life an unforgettable family that faces hardship with rare grit and determination.<br/><br/>“Meadows paints the Bell family’s desperation with compassion and warmth, and her precise language turns grit into gold.” —Emma Straub, <i>New York Times</i>–bestselling author of <i>Modern Lovers</i><br/><br/>“Meticulously researched, deeply felt, and beautifully written.” —Curtis Sittenfeld, <i>New York Times</i>–bestselling author of Prep and Eligible<br/><br/>“A vibrant, absorbing novel.” —<i>Publishers Weekly</i>, starred review<br/><br/>“An exceptional talent . . . Similar to John Steinbeck’s haunting portrait of tenant farmers in <i>The Grapes of Wrath</i>, but also with the gritty, bittersweet elements in Rilla Askew’s <i>Harpsong</i> and the poignant lyricism of Karen Hesse’s <i>Out of the Dust</i>.” —<i>Booklist</i>, starred review</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rae Meadows
      </h2>
      
      <p class="authorDescription body article"><B>Rae Meadows</B> is the author of <I>Calling Out</I>, which received the 2006 Utah Book Award for fiction, <I>No One Tells Everything</I>, a <I>Poets & Writers</I> Notable Novel, and the widely praised novel, <I>Mercy Train</I>. She lives with her husband and two daughters in Brooklyn, New York.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Henry Holt and Company
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?eea5471e